import React from "react";
import { Paragraph, Link } from "components/core/Typography";

const DescriptionParagraph = () => (
	<Paragraph>
		We&apos;re real people, and we like working to meet your needs. Whether
		you&apos;re searching for the best deal on self-storage or trying to
		update an existing reservation,{" "}
		<Link
			href="https://www.storage.com/"
			className="no-underline"
		>
			Storage.com
		</Link>{" "}
		is here for you. Reach out and contact us via phone or email. You can
		even go the old-fashioned way -- snail mail us in Austin, TX.
	</Paragraph>
);

export default DescriptionParagraph;
